import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-countdown-clock__label" }
const _hoisted_3 = { class: "gfu-countdown-clock__value" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), {
    class: "gfu-countdown-clock",
    "data-qa": $props.dataQa
  }, {
    default: _withCtx(() => [
      ($options.isClockVisible)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.segments, (segment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: segment.key
            }, [
              _createElementVNode("div", {
                class: "gfu-countdown-clock__value",
                "data-qa": `clock-segment:${segment.key}`
              }, _toDisplayString(segment.value), 9 /* TEXT, PROPS */, _hoisted_1),
              _createElementVNode("div", _hoisted_2, _toDisplayString(segment.label), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : _renderSlot(_ctx.$slots, "finished", {
            key: 1,
            dataQa: "countdown-clock-imminent"
          }, () => [
            _createElementVNode("div", _hoisted_3, _toDisplayString($props.elapsedMessage), 1 /* TEXT */),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gfu-countdown-clock__label" }, null, -1 /* CACHED */))
          ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["data-qa"]))
}